import React from "react";
import ScreenshotList from "../data-list/ScreenshotList";

const Screenshots = () => {
  return (
    <div className="pricing-table-area pt--40 pt_sm--100" id="screenshots">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title text-center mb--40">
              <h2>
                APP <span className="theme-color">SCREENSHOTS</span>
              </h2>
              <p>Let's preview our app in summary</p>
            </div>
          </div>
        </div>
        <div className="row mt--30">
          <div className="outerCarousel">
            <ScreenshotList />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Screenshots;
